"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.doTransform = exports.validateAttachHeaderConfig = void 0;
const common_1 = require("@finley-technologies/common");
const validateAttachHeaderConfig = (transformation) => {
    const errors = [];
    const { fields, delimiter } = transformation;
    const effectiveSeperator = delimiter || ',';
    if (fields.length === 0) {
        errors.push({
            type: 'metadataValidation',
            message: 'attachHeader: atleast 1 field is required',
        });
    }
    fields.forEach((field, index) => {
        // we don't want to allow empty strings
        if (field.trim() === '') {
            errors.push({
                type: 'metadataValidation',
                message: `attachHeader: fields[${index}] cannot be empty`,
            });
        }
        // ensure that field does not have invalid characters
        const invalidCharactors = ['\n', '\r', effectiveSeperator];
        invalidCharactors.forEach((char) => {
            if (field.includes(char)) {
                errors.push({
                    type: 'metadataValidation',
                    message: `attachHeader: fields[${index}] contains invalid character(s)`,
                });
            }
        });
    });
    if (errors.length > 0) {
        throw errors;
    }
    return null;
};
exports.validateAttachHeaderConfig = validateAttachHeaderConfig;
const doTransform = ({ srcDataTapeBuffer, transformation, }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { fields, delimiter } = transformation;
        const effectiveSeperator = delimiter || ',';
        const headerString = fields.join(effectiveSeperator);
        const headerBuffer = common_1.finleyBuffer.fromString(`${headerString}\n`);
        // generate the output buffer by concatenating the header buffer and the input buffer
        const outputBuffer = new Uint8Array(headerBuffer.length + srcDataTapeBuffer.length);
        outputBuffer.set(headerBuffer);
        outputBuffer.set(srcDataTapeBuffer, headerBuffer.length);
        return { isValid: true, data: { outputBuffer }, supplementals: [] };
    }
    catch (err) {
        const message = err instanceof common_1.error.FinleyError ? err.message : String(err);
        return {
            isValid: false,
            errors: [
                {
                    type: 'metadataValidation',
                    message,
                },
            ],
        };
    }
});
exports.doTransform = doTransform;
exports.default = {
    doTransform: exports.doTransform,
    validateAttachHeaderConfig: exports.validateAttachHeaderConfig,
};
//# sourceMappingURL=attachHeader-transform.js.map